import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Logger } from 'utilities';
import { apiSsoTokenExchange } from '../services/SsoServiceModified';

const useExchangeToken = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tokenExchangeHasFailed, setTokenExchangeHasFailed] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const exchangeToken = useCallback(
    async (exchangeTicket: string, remember: boolean) => {
      try {
        setIsLoading(true);
        const response = await apiSsoTokenExchange(
          {
            exchange_ticket: exchangeTicket,
            remember,
          },
          { withCredentials: true }
        );
        return response;
      } catch (error) {
        Logger.error('Error exchanging SSO token:', error);
        enqueueSnackbar('Failed to exchange SSO token', { variant: 'error' });
        setTokenExchangeHasFailed(true);
        return undefined;
      } finally {
        setIsLoading(false);
      }
    },
    [enqueueSnackbar]
  );

  return { exchangeToken, isLoading, tokenExchangeHasFailed, setTokenExchangeHasFailed };
};
export default useExchangeToken;
